module.exports = __webpack_public_path__ + "static/legend-sk-418cb5151cb390dcdd5cd325a4e666c7.svg";